import {CLEAR} from "./user";
import {push} from "connected-react-router";
import {StateTree,search,addNode} from './StateTree';
import config from "../config";
export const SET_STREAMS = 'user/SET_STREAMS'
export const ADD_STREAM = 'user/ADD_STREAM'
const initialState = []



export default (state = initialState, action) => {
    switch (action.type) {
        case SET_STREAMS:
            return action.data;
        case ADD_STREAM:
            addNode(state,action.data.parentid, action.data.data.streamEntryDrafts.id, {...action.data.data.streamEntryDrafts,_id:action.data.data.streamEntryDrafts.id});
            return {...state};
        case CLEAR:
            return initialState;
        default:
            return state
    }
}
export const getMessages = (accountId) => {
    return dispatch => {
        fetch(`${config.host}/messages/${accountId}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(data=>data.json())
            .then((json) => {
                if(json.error) {
                    dispatch(push('/login'));
                } else {
                    const tree = new StateTree();
                    addNode(tree,-1, -1, {});
                    for(let j=0; j<json.length; j++) {
                        for (let i = 0; i < json[j].length; i++) {
                            let stream = json[j][i];
                            if (stream.threadId) { //Personal messages
                                if (!search(tree, stream.threadId)) {
                                    addNode(tree, -1, stream.threadId, {});
                                }
                                addNode(tree, stream.threadId, stream._id, stream);
                            } else {
                                addNode(tree, stream.links._parent ? stream.links._parent.toString() : -1, stream._id.toString(), stream);
                            }
                        }
                    }
                    dispatch({type: SET_STREAMS, data: tree})
                }

            })
            .catch((err) => {
                dispatch(push('/login'));
                console.error(err);
            });
    }
}
export const postMessage = (user, account, node) => {
    return dispatch => {
        fetch(`/v2/${user.orgId}/socialnetworkintegration/streamentrydrafts/`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic ${btoa(user.username + ":" + user.password)}`
                },
                method: 'post',
                body: JSON.stringify(
                    {
                        streamEntryDrafts:
                            {
                                status: 'scheduled',
                                content: document.getElementById(`messageInput${node.id}`).value,
                                parentStreamEntryId: `${node.data._id}`,
                                links: {
                                    socialNetworkStreams:
                                        [`${account.id}`]
                                }
                            }
                    }
                )
            }
        )
            .then((response) => response.json())
            .then(json => {
                dispatch({type: ADD_STREAM, data: {parentid: node.id, data: json}})
            })
            .catch(e => console.error(e));
    }
}


// WEBPACK FOOTER //
// ./src/modules/streams.js